import * as React from "react";
import { Box, Grid } from "@material-ui/core";
import { tl } from "../../../../utils";
import { SvgIcon } from "../../../../components";
import { BenefitField } from "./benefitField";
import { IBenefitPlan } from "../../Courses/GroupSettings/types";
import { IIdBenefit } from "../../Courses/GroupSettings/types";
import { themeVariables } from "../_Theme";

interface IProps {
  plans: IBenefitPlan[];
  planBenefitSelected: IIdBenefit;
  onPlanBenefitSelected: (planBenefit: IIdBenefit) => void;
  getCurrency: (code: string) => string;
}

export const MUIPlanChoise = ({
  plans,
  planBenefitSelected,
  onPlanBenefitSelected,
  getCurrency,
}: IProps) => {
  const getCoursesAvailable = () => {
    const plan = plans.find((plan) => plan.id === planBenefitSelected.id);
    return plan ? (
      <Grid container spacing={1} wrap="nowrap">
        <Grid item>{plan.settings.limit}</Grid>
        <Grid item>
          <SvgIcon type={"coursecount"} />
        </Grid>
      </Grid>
    ) : (
      ""
    );
  };

  const planSelected = plans.find((plan) => plan.id === planBenefitSelected.id);
  const beneSelected = planSelected
    ? planSelected.benefits.find(
        (bene) => bene.id === planBenefitSelected.benefitId
      )
    : null;

  const getTotalPrice = () => {
    return beneSelected?.price ? (
      <Grid container spacing={1} wrap="nowrap">
        <Grid item>
          <Box pl={2}>
            {beneSelected.price}{" "}
            {beneSelected.currency ? getCurrency(beneSelected.currency) : ""}
          </Box>
        </Grid>
        <Grid item>
          <Box pl={2}>
            {Math.round(beneSelected.price / beneSelected.period)} {" "}
            {beneSelected.currency
              ? getCurrency(beneSelected.currency)
              : "" + tl("/мес.")}
          </Box>
        </Grid>
      </Grid>
    ) : (
      ""
    );
  };

  const getLabel = () =>
    tl(
      planBenefitSelected.benefitId === -1 || !beneSelected.price
        ? "Бесплатный демо-доступ:"
        : "Срок продления подписки:"
    );

  const onPlanChanged = (planId: number) => {
    planBenefitSelected.id = planId;
    const benefitTemp = plans.find((plan) => plan.id === planId)?.benefits[0];
    planBenefitSelected.benefitId = benefitTemp?.id || 0;
    onPlanBenefitSelected({ ...planBenefitSelected });
  };
  const onBenefitChange = (benefitValue: number) => {
    planBenefitSelected.benefitId = benefitValue;
    onPlanBenefitSelected({ ...planBenefitSelected });
  };

  const getPeriod = (period: number) => {
    switch (period) {
      case 31:
        return "1 месяц";
      case 1:
        return "1 день";
      case 2:
      case 3:
        return period + " дня";
      case 7:
      case 10:
      case 14:
        return period + " дней";
    }
  };

  return planSelected && planBenefitSelected ? (
    <>
      <BenefitField
        list={plans}
        value={planBenefitSelected?.id}
        changeValue={onPlanChanged}
        label={tl("Добавить на тариф:")}
        isDescription
      >
        <Box p={1}>{getCoursesAvailable()}</Box>
      </BenefitField>
      {!!planSelected.benefits?.length ? (
        <BenefitField
          list={planSelected.benefits}
          value={planBenefitSelected.benefitId}
          namePeriod
          trialPeriod={
            planSelected.settings.trial
              ? getPeriod(planSelected.settings.trialPeriod)
              : ""
          }
          changeValue={onBenefitChange}
          label={getLabel()}
        >
          {getTotalPrice()}
        </BenefitField>
      ) : planSelected.settings.trial ? (
        <Box py={2} px={2.5} textAlign="center">
          {tl(
            "Бесплатный демо-доступ " +
              getPeriod(planSelected.settings.trialPeriod)
          )}
        </Box>
      ) : (
        <Box py={2} px={2.5} textAlign="center">
          {tl("Тариф не настроен")}
        </Box>
      )}
    </>
  ) : (
    <Box
      py={2}
      px={2.5}
      textAlign="center"
      color={themeVariables.palette.error.main}
    >
      {tl("Тариф не настроен.")}
    </Box>
  );
};
